function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "diversity",
  transform: "translate(-2.25 -2.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_148800",
  d: "M16.2,9.224A6.974,6.974,0,1,1,9.224,2.25,6.974,6.974,0,0,1,16.2,9.224ZM21.532,16.2H33.019a1.214,1.214,0,0,0,1.05-.591,1.247,1.247,0,0,0,0-1.2L28.326,2.923a1.3,1.3,0,0,0-2.2,0L20.383,14.41a1.247,1.247,0,0,0,0,1.2A1.214,1.214,0,0,0,21.532,16.2ZM10.045,20.662a1.231,1.231,0,0,0-1.739,0L2.611,26.455a1.231,1.231,0,0,0,0,1.739L8.4,33.889a1.231,1.231,0,0,0,1.739,0l5.744-5.744a1.231,1.231,0,0,0,0-1.739ZM33.019,20.3H21.532A1.247,1.247,0,0,0,20.3,21.532V33.019a1.247,1.247,0,0,0,1.231,1.231H33.019a1.247,1.247,0,0,0,1.231-1.231V21.532A1.247,1.247,0,0,0,33.019,20.3Z",
  fill: "currentColor"
}));

function SvgShapes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapes);
export default __webpack_public_path__ + "static/media/shapes.e12f4ba5.svg";
export { ForwardRef as ReactComponent };